import React from 'react';
import styled from "styled-components"
import Title from "@airasia/phoenix-components/components/Title"
import Text from "@airasia/phoenix-components/components/Text"
import Tabs from '../Tabs';
import TabPanel from './TabPanel';
import _ from "lodash";
import ReactHtmlParser from 'react-html-parser';


const Container = styled.div`
    width: 100%;
    // border: 1px solid red;
`;

const getSubTitle = (data, flightDataKeys, searchType) => {
    const flightsList = _.get(data, _.get(flightDataKeys, `${searchType}.flightsList`));
    const currency =  flightsList?.[0]?.userCurrencyCode || "MYR";
    const value = _.ceil(_.get(_.minBy(flightsList, o => o?.convertedPrice), 'convertedPrice', '-'));
    return `${currency} ${value}`
}

const titles = ['Recommended', 'Next Month', 'Next Week'];

const FlightCardsSection = ({tabTitles=titles, title="", subTitle="", data=[], noTab=false, isLoading = false, width = "xs", flightDataKeys={}, searchType='paired', sortBy='cheapest', viewMoreFlightsLink='https://www.airasia.com', selectFlightLink=''}) => {
    if(!isLoading && _.isEmpty(data)){
        return null
    }
    return(
        <Container>
            <Title type="h2">{title}</Title>
            <Text>{ReactHtmlParser(subTitle)}</Text>
            {
                !noTab
                    ?   <Tabs emptyContentDisplay={<TabPanel isLoading={false} data={[]} />} isDisplayNilWhenEmpty isLoading={isLoading} loadingContent={<TabPanel isLoading={isLoading} data={{}} />} tabs={data.map((x, i) => ({title:tabTitles[i], subTitle: getSubTitle(x, flightDataKeys, searchType), content: <TabPanel viewMoreFlightsLink={viewMoreFlightsLink} selectFlightLink={selectFlightLink} sortBy={sortBy} flightDataKeys={flightDataKeys} searchType={searchType} deviceType={width} isLoading={isLoading} data={x} title={tabTitles[i]}/>}))} />
                    :   <TabPanel viewMoreFlightsLink={viewMoreFlightsLink} selectFlightLink={selectFlightLink} deviceType={width} data={data} sortBy={sortBy} flightDataKeys={flightDataKeys} searchType={searchType} isLoading={isLoading} />
            }
            
        </Container>
    )
}

export const HotelsCardsSection = ({title="Hotels near Airport", subTitle="", data=[], isLoading=false, width = "xs"}) => {
    if(!isLoading && _.isEmpty(data)){
        return null
    }
    return(
        <Container>
            <Title type="h2">{title}</Title>
            <Text>{ReactHtmlParser(subTitle)}</Text>
            <TabPanel width={width} isHotels data={data} isLoading={isLoading} viewMoreHotelsLink='https://www.airasia.com' />
        </Container>
    )
};

export default FlightCardsSection;
